export const dummyDecks = [
  {
    id: '1',
    name: 'Fire Power Deck',
    description: 'A powerful deck focused on Fire-type Pokemon with Charizard ex as the centerpiece',
    cards: [
      {
        id: 'a033',
        name: 'Charmander',
        type: 'Fire',
        img_url: 'https://static0.gamerantimages.com/wordpress/wp-content/uploads/2024/11/pokemon-pocket-tcg-a033-charmander.png'
      },
      {
        id: 'a034',
        name: 'Charmeleon',
        type: 'Fire',
        img_url: 'https://static0.gamerantimages.com/wordpress/wp-content/uploads/2024/11/pokemon-pocket-tcg-a034-charmeleon.png'
      },
      {
        id: 'a035',
        name: 'Charizard',
        type: 'Fire',
        img_url: 'https://static0.gamerantimages.com/wordpress/wp-content/uploads/2024/11/pokemon-pocket-tcg-a035-charizard.png'
      },
      {
        id: 'a036',
        name: 'Charizard ex',
        type: 'Fire',
        img_url: 'https://static0.gamerantimages.com/wordpress/wp-content/uploads/2024/11/pokemon-pocket-tcg-a036-charizard-ex.png'
      },
      {
        id: 'a037',
        name: 'Vulpix',
        type: 'Fire',
        img_url: 'https://static0.gamerantimages.com/wordpress/wp-content/uploads/2024/11/pokemon-pocket-tcg-a037-vulpix.png'
      },
      {
        id: 'a038',
        name: 'Ninetales',
        type: 'Fire',
        img_url: 'https://static0.gamerantimages.com/wordpress/wp-content/uploads/2024/11/pokemon-pocket-tcg-a038-ninetales.png'
      }
    ],
    type: 'Standard',
    isPublic: true,
    creatorId: 'user1',
    createdAt: '2024-03-15T10:00:00.000Z',
    updatedAt: '2024-03-15T10:00:00.000Z'
  },
  {
    id: '2',
    name: 'Grass Evolution',
    description: 'A strategic deck built around Grass-type evolution chains',
    cards: [
      {
        id: 'a001',
        name: 'Bulbasaur',
        type: 'Grass',
        img_url: 'https://static0.gamerantimages.com/wordpress/wp-content/uploads/2024/11/pokemon-pocket-tcg-a001-bulbasaur.png'
      },
      {
        id: 'a002',
        name: 'Ivysaur',
        type: 'Grass',
        img_url: 'https://static0.gamerantimages.com/wordpress/wp-content/uploads/2024/11/pokemon-pocket-tcg-a002-ivysaur.png'
      },
      {
        id: 'a003',
        name: 'Venusaur',
        type: 'Grass',
        img_url: 'https://static0.gamerantimages.com/wordpress/wp-content/uploads/2024/11/pokemon-pocket-tcg-a003-venusaur.png'
      },
      {
        id: 'a004',
        name: 'Venusaur ex',
        type: 'Grass',
        img_url: 'https://static0.gamerantimages.com/wordpress/wp-content/uploads/2024/11/pokemon-pocket-tcg-a004-venusaur-ex.png'
      }
    ],
    type: 'Theme',
    isPublic: true,
    creatorId: 'user2',
    createdAt: '2024-03-14T15:30:00.000Z',
    updatedAt: '2024-03-14T15:30:00.000Z'
  },
  {
    id: '3',
    name: 'Bug Masters',
    description: 'A unique deck featuring powerful Bug-type Pokemon',
    cards: [
      {
        id: 'a005',
        name: 'Caterpie',
        type: 'Bug',
        img_url: 'https://static0.gamerantimages.com/wordpress/wp-content/uploads/2024/11/pokemon-pocket-tcg-a005-caterpie.png'
      },
      {
        id: 'a006',
        name: 'Metapod',
        type: 'Bug',
        img_url: 'https://static0.gamerantimages.com/wordpress/wp-content/uploads/2024/11/pokemon-pocket-tcg-a006-metapod.png'
      },
      {
        id: 'a007',
        name: 'Butterfree',
        type: 'Bug',
        img_url: 'https://static0.gamerantimages.com/wordpress/wp-content/uploads/2024/11/pokemon-pocket-tcg-a007-butterfree.png'
      },
      {
        id: 'a008',
        name: 'Weedle',
        type: 'Bug',
        img_url: 'https://static0.gamerantimages.com/wordpress/wp-content/uploads/2024/11/pokemon-pocket-tcg-a008-weedle.png'
      },
      {
        id: 'a009',
        name: 'Kakuna',
        type: 'Bug',
        img_url: 'https://static0.gamerantimages.com/wordpress/wp-content/uploads/2024/11/pokemon-pocket-tcg-a009-kakuna.png'
      },
      {
        id: 'a010',
        name: 'Beedrill',
        type: 'Bug',
        img_url: 'https://static0.gamerantimages.com/wordpress/wp-content/uploads/2024/11/pokemon-pocket-tcg-a010-beedrill.png'
      }
    ],
    type: 'Expanded',
    isPublic: false,
    creatorId: 'user1',
    createdAt: '2024-03-13T09:15:00.000Z',
    updatedAt: '2024-03-13T09:15:00.000Z'
  }
]; 